import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31b5b9d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters p-d-flex p-jc-between p-mb-2" }
const _hoisted_2 = { class: "p-d-flex" }
const _hoisted_3 = {
  key: 1,
  cellspacing: "0"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommunityTag = _resolveComponent("CommunityTag")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_PlaceholderState = _resolveComponent("PlaceholderState")!
  const _component_list_card_comision = _resolveComponent("list-card-comision")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
          return (_openBlock(), _createBlock(_component_CommunityTag, {
            class: "p-mr-2",
            key: tag.key,
            value: tag.val,
            defaultState: false,
            onClick: () => _ctx.handleTagActive(tag.label)
          }, null, 8, ["value", "onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          label: _ctx.filterOptions.find((op) => op.value === _ctx.btnFilter)?.label || _ctx.copies.studentChangeCourse.filter.menu.menu1,
          class: "p-button-filter p-button-lg",
          icon: "pi pi-angle-down",
          iconPos: "right",
          onClick: _ctx.handleFilterToggle,
          "aria-haspopup": "true",
          "aria-controls": "menu-change-course",
          style: {"color":"var(--light-gray)"}
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Menu, {
          id: "menu-change-course",
          ref: "menu",
          model: _ctx.filterOptions,
          popup: true
        }, null, 8, ["model"])
      ])
    ]),
    (_ctx.secondFilterIncomingClasses.length === 0)
      ? (_openBlock(), _createBlock(_component_PlaceholderState, {
          key: 0,
          role: 2,
          isEmpty: true,
          customCopies: { line1: _ctx.copies.studentChangeCourse.emptyState }
        }, null, 8, ["customCopies"]))
      : (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_4,
              _createElementVNode("th", null, _toDisplayString(_ctx.copies.studentChangeCourse.table.teacher), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.copies.studentChangeCourse.table.comision), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.copies.studentChangeCourse.table.days), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.copies.studentChangeCourse.table.schedule), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.copies.studentChangeCourse.table.duration), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createVNode(_component_list_card_comision, {
              options: _ctx.secondFilterIncomingClasses,
              name: "transfer-course",
              onOnUpdateValue: _ctx.handleChooseCourse
            }, null, 8, ["options", "onOnUpdateValue"])
          ])
        ]))
  ], 64))
}